import { useToasts } from '@/store/toast';
import { cn } from '@/lib/utils';

export function Toaster() {
  const { toasts, drop } = useToasts();
  return (
    <div className="fixed bottom-4 right-4 z-[60] flex w-80 flex-col gap-2" role="status">
      {toasts.map((t) => (
        <div key={t.id} onClick={() => drop(t.id)} data-testid={`toast-${t.kind}`}
             className={cn('cursor-pointer rounded-lg border px-4 py-3 text-sm shadow-md bg-background', t.kind === 'error' ? 'border-destructive text-destructive' : 'border-success')}>
          {t.text}
        </div>
      ))}
    </div>
  );
}
